import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SelectField, TextButton } from '@oneaudi/unified-web-components';
import useFetchDealersByMarket, { Dealer } from '../../hooks/fetchHooks/useFetchDealersByMarket';
import { selectAppConfig } from '../../redux/appConfigReducer';

const ServiceSchedule = () => {
  const { t } = useTranslation();
  const { uniqueRegions, getDealersByRegion, loading } = useFetchDealersByMarket();
  const { market } = useSelector(selectAppConfig);

  const isUSMarket = market?.toLowerCase().includes('us');

  const [province, setProvince] = React.useState<string>('');
  const [dealers, setDealers] = React.useState<Dealer[]>([]);
  const [dealerSelected, setDealerSelected] = React.useState<Dealer | null>(null);

  React.useEffect(() => {
    if (province) {
      const dealersByRegion = getDealersByRegion(province);
      setDealers(dealersByRegion);
    }
  }, [province, getDealersByRegion]);

  const onHandleProvinceChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setProvince(e.target.value);
  };

  const onHandleDealerChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedDealer = dealers.find((dealer) => dealer.name === e.target.value) || null;
    setDealerSelected(selectedDealer);
  };

  return (
    <>
      <SelectField
        label={t('digitalLeads.inputs.schedServiceProvince')}
        id="dropdown-selector"
        onChange={onHandleProvinceChange}
        disabled={loading}
        value={province}
      >
        <option key="default" data-testid="dropdown-option-checkbox-default" value="">
          {' '}
        </option>
        {uniqueRegions.map((option) => {
          return (
            <option key={option} data-testid={`dropdown-option-checkbox-${option}`} value={option}>
              {option}
            </option>
          );
        })}
      </SelectField>

      {province && (
        <SelectField
          label={t('digitalLeads.inputs.schedServiceDealer')}
          hint={t('digitalLeads.inputs.schedServiceDealerHint')}
          id="dropdown-selector"
          margin={['24px', 0, '48px', 0]}
          onChange={onHandleDealerChange}
          disabled={!province}
          value={dealerSelected?.name || ''}
        >
          <option key="default" data-testid="dropdown-option-checkbox-default" value="">
            {' '}
          </option>
          {dealers.map((option) => {
            const { name } = option;
            return (
              <option key={name} data-testid={`dropdown-option-checkbox-${name}`} value={name}>
                {name}
              </option>
            );
          })}
        </SelectField>
      )}

      {dealerSelected && (
        <TextButton
          href={isUSMarket ? dealerSelected.requestServiceEn : dealerSelected.requestServiceFr}
          isFullWidth
          variant="primary"
        >
          {t('digitalLeads.inputs.schedServiceButton')}
        </TextButton>
      )}
    </>
  );
};

export default ServiceSchedule;
